import { render } from "./CulinaryPanel.vue?vue&type=template&id=a65b260e&scoped=true"
import script from "./CulinaryPanel.vue?vue&type=script&lang=js"
export * from "./CulinaryPanel.vue?vue&type=script&lang=js"

import "./CulinaryPanel.vue?vue&type=style&index=0&id=a65b260e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65b260e"]])

export default __exports__